import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiCheckCircle, BiUser, BiShoppingBag, BiEdit, BiSync, BiShield, BiRocket, BiCodeCurly } from 'react-icons/bi';

const WooCommerceSchnittstelleFeatures = () => {
    const { t } = useTranslations();

    const features = [
        {
            icon: BiUser,
            title: t('woocommerceSchnittstelle_features_customer_title'),
            description: t('woocommerceSchnittstelle_features_customer_desc'),
        },
        {
            icon: BiShoppingBag,
            title: t('woocommerceSchnittstelle_features_order_title'),
            description: t('woocommerceSchnittstelle_features_order_desc'),
        },
        {
            icon: BiEdit,
            title: t('woocommerceSchnittstelle_features_product_title'),
            description: t('woocommerceSchnittstelle_features_product_desc'),
        },
        {
            icon: BiSync,
            title: t('woocommerceSchnittstelle_features_sync_title'),
            description: t('woocommerceSchnittstelle_features_sync_desc'),
        },
        {
            icon: BiShield,
            title: t('woocommerceSchnittstelle_features_security_title'),
            description: t('woocommerceSchnittstelle_features_security_desc'),
        },
        {
            icon: BiRocket,
            title: t('woocommerceSchnittstelle_features_performance_title'),
            description: t('woocommerceSchnittstelle_features_performance_desc'),
        },
        {
            icon: BiCodeCurly,
            title: t('woocommerceSchnittstelle_features_formats_title'),
            description: t('woocommerceSchnittstelle_features_formats_desc'),
        },
        {
            icon: BiCheckCircle,
            title: t('woocommerceSchnittstelle_features_easy_title'),
            description: t('woocommerceSchnittstelle_features_easy_desc'),
        }
    ];

    return (
        <section className="wc-features pt-100 pb-100">
            <div className="wc-features__decoration"></div>

            <div className="container wc-features__content">
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="wc-section-badge">
                                {t('woocommerceSchnittstelle_features_badge')}
                            </span>
                            <h2 className="wc-section-title wc-section-title--gradient">
                                {t('woocommerceSchnittstelle_features_title')}
                            </h2>
                            <p className="wc-section-subtitle">
                                {t('woocommerceSchnittstelle_features_subtitle')}
                            </p>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row">
                    {features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <div key={index} className="col-lg-3 col-md-6 mb-4 d-flex">
                                <FadeInAnimation direction="up" delay={100 + (index * 50)} style={{ display: 'flex', width: '100%' }}>
                                    <div className="wc-features__card">
                                        <div className="wc-features__icon-box">
                                            <Icon />
                                        </div>
                                        <h3 className="wc-features__card-title">
                                            {feature.title}
                                        </h3>
                                        <p className="wc-features__card-desc">
                                            {feature.description}
                                        </p>
                                    </div>
                                </FadeInAnimation>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstelleFeatures;
